var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGoogle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Google Logo"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M23.06 12.25C23.06 11.47 22.99 10.72 22.86 10H12.5V14.26H18.42C18.16 15.63 17.38 16.79 16.21 17.57V20.34H19.78C21.86 18.42 23.06 15.6 23.06 12.25Z",
    fill: "#4285F4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M12.4999 22.9996C15.4699 22.9996 17.9599 22.0196 19.7799 20.3396L16.2099 17.5696C15.2299 18.2296 13.9799 18.6296 12.4999 18.6296C9.63993 18.6296 7.20993 16.6996 6.33993 14.0996H2.67993V16.9396C4.48993 20.5296 8.19993 22.9996 12.4999 22.9996Z",
    fill: "#34A853"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M6.34 14.0903C6.12 13.4303 5.99 12.7303 5.99 12.0003C5.99 11.2703 6.12 10.5703 6.34 9.91031V7.07031H2.68C1.93 8.55031 1.5 10.2203 1.5 12.0003C1.5 13.7803 1.93 15.4503 2.68 16.9303L5.53 14.7103L6.34 14.0903Z",
    fill: "#FBBC05"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M12.4999 5.38C14.1199 5.38 15.5599 5.94 16.7099 7.02L19.8599 3.87C17.9499 2.09 15.4699 1 12.4999 1C8.19993 1 4.48993 3.47 2.67993 7.07L6.33993 9.91C7.20993 7.31 9.63993 5.38 12.4999 5.38Z",
    fill: "#EA4335"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGoogle);
export default __webpack_public_path__ + "static/media/google.7ef23541fa300abd70389e1c29d2cc19.svg";
export { ForwardRef as ReactComponent };